if (!customElements.get('raw-athletic-motion')) {
  customElements.define('raw-athletic-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.motionReady) return;
      this.motionReady = true;
      this.button = this.querySelector('.raw-impact-hero__motion-toggle');
      if (!this.button) return;
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = true;
      this.updateMotion = () => {
        const reduced = this.preference.matches;
        this.dataset.motion = reduced || this.userPaused || !this.inView || document.hidden ? 'paused' : 'playing';
        this.button.hidden = reduced;
        this.button.setAttribute('aria-pressed', String(this.userPaused));
        this.button.querySelector('[data-motion-label]').textContent = this.userPaused ? 'PLAY MOTION' : 'PAUSE MOTION';
      };
      this.toggleMotion = () => { this.userPaused = !this.userPaused; this.updateMotion(); };
      this.button.addEventListener('click', this.toggleMotion);
      this.preference.addEventListener('change', this.updateMotion);
      document.addEventListener('visibilitychange', this.updateMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateMotion();
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      this.updateMotion();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggleMotion);
      this.preference?.removeEventListener('change', this.updateMotion);
      document.removeEventListener('visibilitychange', this.updateMotion);
      this.motionReady = false;
    }
  });
}
